<div
  id="SUPPORT-ICT"
  class="page-layout blank"
  class="page-layout simple"
  fxLayout="column">
  <!-- HEADER -->
  <div
    class="header"
    fxLayout="column"
    fxLayoutAlign="center center"
    fxLayout.gt-sm="row"
    fxLayoutAlign.gt-sm="space-between end">
    <div
      class="name"
      [@animate]="{ value: '*', params: { delay: '100ms', x: '-25px' } }">
      {{ 'SUPPORT-ICT.TITLE' | translate }}
    </div>
    <div class="center" fxLayout="row">
      <!-- SEARCH -->
      <div class="search-wrapper">
        <div class="search" fxFlex fxLayout="row" fxLayoutAlign="start center">
          <mat-icon>search</mat-icon>
          <input #servicefilter matInput [(ngModel)]="searchText" />
        </div>
      </div>
      <!-- / SEARCH -->
    </div>
  </div>
  <!-- / HEADER -->
  <div class="content-card" fxFill>
    @if (selectedUser) {
      <div class="content">
        <div fxLayout="row wrap" fxLayoutGap="15px">
          <div class="app-card">
            <div class="row" class="image-description">
              <div fxFlex="20">
                <mat-icon class="card-icon">person_add</mat-icon>
              </div>
            </div>
            <div class="title-container">
              <div class="title">{{ 'SUPPORT-ICT.ADDUSER' | translate }}</div>
              <div class="subtitle secondary-text">
                {{ 'SUPPORT-ICT.ADDFORM' | translate }}
              </div>
            </div>
            <div class="description">
              <div class="serviceDesc" fxFlex="80">
                {{ 'SUPPORT-ICT.ADDUSER' | translate }}
              </div>
            </div>
            <div class="action" fxLayout="row" fxLayoutAlign="start center">
              <button
                mat-button
                color="accent"
                class="access-btn"
                (click)="newUser()"
                [disabled]="isUserAddDisabled"
                [ngClass]="{ disabled: isUserAddDisabled }">
                {{ 'GENERAL.ACCESS' | translate }}
              </button>
            </div>
          </div>
          <div class="app-card">
            <div class="row" class="image-description">
              <div fxFlex="20">
                <mat-icon class="card-icon">group_add</mat-icon>
              </div>
            </div>
            <div class="title-container">
              <div class="title">
                {{ 'GENERAL.TITLE.IMPORTUSER' | translate }}
              </div>
              <div class="subtitle secondary-text">
                {{ 'SUPPORT-ICT.IMPORTFORM' | translate }}
              </div>
            </div>
            <div class="description">
              <div class="serviceDesc" fxFlex="80">
                {{ 'SUPPORT-ICT.IMPORTFROMTEMPLATE' | translate }}
              </div>
            </div>
            <div class="action" fxLayout="row" fxLayoutAlign="start center">
              <button
                mat-button
                color="accent"
                class="access-btn"
                (click)="importUsers()">
                {{ 'GENERAL.ACCESS' | translate }}
              </button>
            </div>
          </div>
          @if (canAccessToUsers365()) {
            <div class="app-card">
              <div
                class="row"
                fxLayoutAlign="space-between center"
                class="image-description">
                <div fxFlex="25">
                  <img
                    src="../../../assets/images/maintenance/services/M365_ACCOUNT.svg"
                    class="account-office"
                    alt="{{ 'GENERAL.SERVICE_IMAGE' | translate }}" />
                </div>
              </div>
              <div class="title-container">
                <div class="title">
                  {{ 'SUPPORT-ICT.365-USERS.TITLE' | translate }}
                </div>
                <div class="subtitle secondary-text">
                  {{ 'SUPPORT-ICT.365-USERS.SUBTITLE' | translate }}
                </div>
              </div>
              <div class="description">
                <div class="serviceDesc" fxFlex="80">
                  {{ 'SUPPORT-ICT.365-USERS.DESCRIPTION' | translate }}
                </div>
              </div>
              <div class="action" fxLayout="row" fxLayoutAlign="start center">
                <button
                  mat-button
                  color="accent"
                  class="access-btn"
                  (click)="userMicrosoftInfo()">
                  {{ 'GENERAL.ACCESS' | translate }}
                </button>
              </div>
            </div>
          }
          <div class="app-card">
            <div
              class="row"
              fxLayoutAlign="space-between center"
              class="image-description">
              <div fxFlex="25">
                <mat-icon class="card-icon search-icon">person_search</mat-icon>
              </div>
              <img
                src="../../../assets/images/maintenance/services/TEAMS.svg"
                class="office"
                alt="{{ 'GENERAL.SERVICE_IMAGE' | translate }}" />
            </div>
            <div class="title-container">
              <div class="title">
                {{ 'SUPPORT-ICT.DELETED-TEAMS.TITLE' | translate }}
              </div>
              <div class="subtitle secondary-text">
                {{ 'SUPPORT-ICT.DELETED-TEAMS.SUBTITLE' | translate }}
              </div>
            </div>
            <div class="description">
              <div class="serviceDesc" fxFlex="80">
                {{ 'SUPPORT-ICT.DELETED-TEAMS.DESCRIPTION' | translate }}
              </div>
            </div>
            <div class="action" fxLayout="row" fxLayoutAlign="start center">
              <button
                mat-button
                color="accent"
                class="access-btn"
                (click)="listDeletedTeams()">
                {{ 'GENERAL.ACCESS' | translate }}
              </button>
            </div>
          </div>
          <!-- DON'T DELETE
            <div class="app-card">
              <div class="row" fxLayoutAlign="space-between center" class="image-description">
                <div fxFlex="25">
                  <mat-icon class="card-icon search-icon">person_search</mat-icon>
                </div>
                <img src="../../../assets/images/maintenance/services/OFFICE.svg" class="office" alt="{{ 'GENERAL.SERVICE_IMAGE' | translate }}">
              </div>
              <div class="title-container">
                <div class="title">Lister les groupes M365</div>
                <div class="subtitle secondary-text">
                  Tableau des groupes Microsoft 365
                </div>
              </div>
              <div class="description">
                <div class="serviceDesc" fxFlex="80">
                  Lister tous les groupes de sécurité
                </div>
              </div>
              <div class="action" fxLayout="row" fxLayoutAlign="start center">
                <button
                  mat-button
                  color="accent"
                  class="access-btn"
                  (click)="listGroups()">
                  {{ 'GENERAL.ACCESS' | translate}}
                </button>
              </div>
            </div>-->
          <div class="app-card">
            <div class="row" class="image-description">
              <div fxFlex="20">
                <mat-icon class="card-icon">refresh</mat-icon>
              </div>
            </div>
            <div class="title-container">
              <div class="title">
                {{ 'SUPPORT-ICT.RELOADSERVICE' | translate }}
              </div>
              <div class="subtitle secondary-text">
                {{ 'SUPPORT-ICT.APICALL' | translate }}
              </div>
            </div>
            <div class="description">
              <div class="serviceDesc" fxFlex="80">
                {{ 'SUPPORT-ICT.RELOADSERVICEFROMMIDPOINT' | translate }} ({{
                  lastUpdateServiceDate
                }})
              </div>
            </div>
            <div class="action" fxLayout="row" fxLayoutAlign="start center">
              @if (!isLoadingServices) {
                <button
                  mat-button
                  color="accent"
                  class="access-btn"
                  (click)="fetchService()">
                  {{ 'SUPPORT-ICT.RELOAD' | translate }}
                </button>
              }
              @if (isLoadingServices && !hasErrorServiceLoaded) {
                <mat-progress-spinner
                  [color]="spinner.color"
                  [mode]="spinner.mode"
                  [value]="spinner.value"
                  [diameter]="spinner.diameter">
                </mat-progress-spinner>
              }
              @if (isServiceLoaded) {
                <mat-icon class="check-icon" color="primary"
                  >check_circle_outline</mat-icon
                >
              }
              @if (hasErrorServiceLoaded) {
                <mat-icon class="check-icon" color="error"
                  >error_outline</mat-icon
                >
              }
            </div>
          </div>
          <div class="app-card">
            <div class="row" class="image-description">
              <div fxFlex="20">
                <mat-icon class="card-icon">refresh</mat-icon>
              </div>
            </div>
            <div class="title-container">
              <div class="title">
                {{ 'SUPPORT-ICT.RELOADROLE' | translate }}
              </div>
              <div class="subtitle secondary-text">
                {{ 'SUPPORT-ICT.APICALL' | translate }}
              </div>
            </div>
            <div class="description">
              <div class="serviceDesc" fxFlex="80">
                {{ 'SUPPORT-ICT.RELOADROLEFROMMIDPOINT' | translate }} ({{
                  lastupdateRoleDate
                }})
              </div>
            </div>
            <div class="action" fxLayout="row" fxLayoutAlign="start center">
              @if (!isLoadingRoles) {
                <button
                  mat-button
                  color="accent"
                  class="access-btn"
                  (click)="fetchRoles()">
                  {{ 'SUPPORT-ICT.RELOAD' | translate }}
                </button>
              }
              @if (isLoadingRoles && !hasErrorRolesLoaded) {
                <mat-progress-spinner
                  [color]="spinner.color"
                  [mode]="spinner.mode"
                  [value]="spinner.value"
                  [diameter]="spinner.diameter">
                </mat-progress-spinner>
              }
              @if (isRolesLoaded) {
                <mat-icon class="check-icon" color="primary"
                  >check_circle_outline</mat-icon
                >
              }
              @if (hasErrorRolesLoaded) {
                <mat-icon class="check-icon" color="error"
                  >error_outline</mat-icon
                >
              }
            </div>
          </div>
          <div class="app-card">
            <div class="row" class="image-description">
              <div fxFlex="20">
                <mat-icon class="card-icon">refresh</mat-icon>
              </div>
            </div>
            <div class="title-container">
              <div class="title">
                {{ 'SUPPORT-ICT.RELOADTABLE' | translate }}
              </div>
              <div class="subtitle secondary-text">
                {{ 'SUPPORT-ICT.APICALL' | translate }}
              </div>
            </div>
            <div class="description">
              <div class="serviceDesc" fxFlex="80">
                {{ 'SUPPORT-ICT.RELOADTABLEFROMENT' | translate }} ({{
                  lastUpdateCorrespondigTableDate
                }})
              </div>
            </div>
            <div class="action" fxLayout="row" fxLayoutAlign="start center">
              @if (!isLoadingCorrespondingTable) {
                <button
                  mat-button
                  color="accent"
                  class="access-btn"
                  (click)="fetchCorrespondingTable()">
                  {{ 'SUPPORT-ICT.RELOAD' | translate }}
                </button>
              }
              @if (
                isLoadingCorrespondingTable && !hasErrorCorrespondingTableLoaded
              ) {
                <mat-progress-spinner
                  [color]="spinner.color"
                  [mode]="spinner.mode"
                  [value]="spinner.value"
                  [diameter]="spinner.diameter">
                </mat-progress-spinner>
              }
              @if (isCorrespondingTableLoaded) {
                <mat-icon class="check-icon" color="primary"
                  >check_circle_outline</mat-icon
                >
              }
              @if (hasErrorCorrespondingTableLoaded) {
                <mat-icon class="check-icon" color="error"
                  >error_outline</mat-icon
                >
              }
            </div>
          </div>
          @for (service of filterServices; track service) {
            <div class="app-card">
              <div class="row" class="image-description">
                <div fxFlex="20">
                  @if (service.jpegPhoto !== '') {
                    <img
                      src="data:image/png;base64,{{ service.jpegPhoto }}"
                      class="serviceImage"
                      alt="Image du service" />
                  }
                  @if (service.jpegPhoto === '') {
                    <img
                      src="/assets/images/cards/noimage.png"
                      class="serviceImage"
                      alt="Image vide" />
                  }
                </div>
              </div>
              <div class="title-container">
                <div class="title">{{ service.title_fr }}</div>
                <div class="subtitle secondary-text">
                  {{ service.subtitle_fr }}
                </div>
              </div>
              <div class="row description">
                <div class="serviceDesc" fxFlex="80">
                  {{ service.description_fr }}
                </div>
              </div>
              <div class="action" fxLayout="row" fxLayoutAlign="start center">
                <button
                  mat-button
                  color="accent"
                  class="access-btn"
                  (click)="openService(service, 'fr')">
                  {{ 'GENERAL.ACCESS' | translate }}
                </button>
                @if (service.help_fr !== '') {
                  <button
                    mat-button
                    color="accent"
                    (click)="openDocumentation(service.help_fr)">
                    <mat-icon mat-list-icon>help_outline</mat-icon>
                  </button>
                }
              </div>
            </div>
          }
          @if (hasAccessMaintenance) {
            <div class="app-card">
              <div class="row" class="image-description">
                <div fxFlex="20">
                  <mat-icon class="card-icon">settings</mat-icon>
                </div>
              </div>
              <div class="title-container">
                <div class="title">
                  {{ 'SUPPORT-ICT.MAINTENANCE-SETTINGS' | translate }}
                </div>
                <div class="subtitle secondary-text">
                  {{ 'SUPPORT-ICT.APICALL' | translate }}
                </div>
              </div>
              <div class="description">
                <div class="serviceDesc" fxFlex="80">
                  {{
                    'SUPPORT-ICT.MAINTENANCE-SETTINGS-DESCRIPTION' | translate
                  }}
                </div>
              </div>
              <div class="action" fxLayout="row" fxLayoutAlign="start center">
                <button
                  mat-button
                  color="accent"
                  class="access-btn"
                  routerLink="/maintenance-settings">
                  {{ 'GENERAL.ACCESS' | translate }}
                </button>
              </div>
            </div>
          }
          <div class="app-card">
            <div class="row" class="image-description">
              <div fxFlex="20">
                <mat-icon class="card-icon">settings</mat-icon>
              </div>
            </div>
            <div class="title-container">
              <div class="title">Database</div>
              <div class="subtitle secondary-text">
                {{ 'SUPPORT-ICT.APICALL' | translate }}
              </div>
            </div>
            <div class="description">
              <div class="serviceDesc" fxFlex="80">Database logs</div>
            </div>
            <div class="action" fxLayout="row" fxLayoutAlign="start center">
              <button
                mat-button
                color="accent"
                class="access-btn"
                routerLink="/logs">
                {{ 'GENERAL.ACCESS' | translate }}
              </button>
            </div>
          </div>
          <div class="app-card">
            <div class="row" class="image-description">
              <div fxFlex="20">
                <mat-icon class="card-icon">groups</mat-icon>
              </div>
            </div>
            <div class="title-container">
              <div class="title">
                {{ 'SUPPORT-ICT.EXTERNALUSERS' | translate }}
              </div>
              <div class="subtitle secondary-text">
                {{ 'SUPPORT-ICT.APICALL' | translate }}
              </div>
            </div>
            <div class="description">
              <div class="serviceDesc" fxFlex="80">
                {{ 'SUPPORT-ICT.MANAGEEXTERNALUSERS' | translate }}
              </div>
            </div>
            <div class="action" fxLayout="row" fxLayoutAlign="start center">
              <button
                mat-button
                color="accent"
                class="access-btn"
                routerLink="/users-external">
                {{ 'GENERAL.ACCESS' | translate }}
              </button>
            </div>
          </div>
          <div class="app-card">
            <div class="row" class="image-description">
              <div fxFlex="20">
                <mat-icon class="card-icon">handyman</mat-icon>
              </div>
            </div>
            <div class="title-container">
              <div class="title">
                {{ 'SUPPORT-ICT.NEMESIS' | translate }}
              </div>
              <div class="subtitle secondary-text">
                {{ 'SUPPORT-ICT.TITLE' | translate }}
              </div>
            </div>
            <div class="description">
              <div class="serviceDesc" fxFlex="80">
                {{ 'SUPPORT-ICT.NEMESIS' | translate }}
              </div>
            </div>
            <div class="action" fxLayout="row" fxLayoutAlign="start center">
              <button
                mat-button
                color="accent"
                class="access-btn"
                (click)="openNemesis()">
                {{ 'GENERAL.ACCESS' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
